import React from "react"
import type { ItemType } from "types"
import { usePDPUrl } from "components/Basket/hooks/usePDPUrl"
import { SimpleProductCardV2 } from "./SimpleProductCardV2"

type Props = {
  item: ItemType
}

export const SimpleProductCardWrapper: React.FC<Props> = ({ item }) => {
  const pdpUrl = usePDPUrl(item)
  return <SimpleProductCardV2 item={item} href={pdpUrl} />
}
